<template>
    <div class="w-full">
        <div class="form-group">
            <p class="text-center font-weight-bolder">LETS GET STARTED</p>
        </div>

        <div class="form-group">
            <p class="text-center">Create an account</p>
        </div>

        <!-- Name -->
        <div class="form-group">
            <input type="text" placeholder="Enter your name"
                   :class="{'is-invalid': hasError('name')}" class="form-control" @keydown="removeError('name')"
                   style="background-color: #ebebeb" id="name" name="name" v-model="form.name" autocomplete="off" >
            <span class="invalid-feedback" v-show="hasError('name')">{{ getError('name') }}</span>
        </div>

        <!-- E-Mail Address -->
        <div class="form-group">
            <input type="text" placeholder="Enter your work email" :class="{'is-invalid': hasError('email')}" @keydown="removeError('email')"
                   class="form-control" style="background-color: #ebebeb"  name="email" v-model="form.email" autocomplete="nope" :disabled="urlToken && form.email">
            <span class="invalid-feedback" v-show="hasError('email')">{{ getError('email') }}</span>
        </div>

        <!-- Password -->
        <div class="form-group">
            <input type="password" placeholder="Enter your Password"
                   :class="{'is-invalid': hasError('password')}" class="form-control" @keydown="removeError('password')"
                   style="background-color: #ebebeb" id="password" name="password" v-model="form.password" autocomplete="off" >
            <span class="invalid-feedback" v-show="hasError('password')">{{ getError('password') }}</span>
        </div>

        <div class="form-group">
            <input v-model="form.phone" id="cell" name="cell" maxlength="64" placeholder="Enter your phone number"
                   v-mask="['(###) ###-####', '(###) ###-#### ext. #####']" autocomplete="off"
                   class="form-control" style="background-color: #ebebeb" :class="{'is-invalid': hasError('phone')}" @keydown="removeError('phone')">
            <span class="invalid-feedback" v-show="hasError('phone')">{{ getError('phone') }}</span>
        </div>

        <div class="form-group">
            <input type="text" placeholder="Enter your company name" :class="{'is-invalid': hasError('company_name')}" @keydown="removeError('company_name')"
                   class="form-control" style="background-color: #ebebeb" name="company" v-model="form.company_name" autocomplete="off">
            <span class="invalid-feedback" v-show="hasError('company_name')">{{ getError('company_name') }}</span>
        </div>

        <!-- Login Button -->
        <div class="form-group row">
            <div class="col-md-12" style="display: flex; align-items: center; justify-content: center">
                <button class="mr-3 mt-3 btn-primary py-3 px-4 text-white hover:text-white focus:outline-none"
                        style="border-radius: 10px; box-shadow: rgb(160 160 160) 1px 3px 8px 1px;" type="button" id="firstNext" @click="createAccount()">Create Account
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';
export default {
    name: "form-one",
    props: [],
    components: {Datepicker},
    data() {
        return {
            form: {
                name:null,
                email:null,
                password:null,
                phone:null,
                company_name:null
            },
            errors: [],
            urlToken: null,
        }
    },
    mounted(){
        const self = this
        Bus.$on('formValidationError', data => {
            self.errors = data.validationErrors
        });
        let location = new URL(window.location);
        this.urlToken = location.searchParams.get('token');
        if(this.urlToken) {
            let json = JSON.parse(atob(this.urlToken));
            this.form.email = json.email;
        }
    },
    methods: {
        removeError : function (field) {
            const self = this
            if (self.hasError(field)) {
                delete self.errors[field]
            }
        },
        getError : function (field) {
            const self = this;
            if (self.hasError(field)) {
                return self.errors[field];
            }
        },
        checkForm: function () {
            this.errors = [];

            if (this.form.name === null || this.form.name === '') {
                this.errors['name'] = "Name is required.";
            }
            if (this.form.password === null || this.form.password === '') {
                this.errors['password'] = "Password is required.";
            }
            if (this.form.email === null || this.form.email === '') {
                this.errors["email"] = "Email is required.";
            } else if (!this.validEmail(this.form.email)) {
                this.errors["email"]="Email is invalid.";
            }
            if (this.form.phone === null || this.form.phone === '') {
                this.errors["phone"]= "Phone is required.";
            }
            if (this.form.company_name === null || this.form.company_name === '') {
                this.errors["company_name"] = "Company name is required.";
            }

            for (const key in this.errors){
                if(!!key){
                    return true
                }
            }
            return false
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        hasError: function (field) {
            return _.indexOf(_.keys(this.errors), field) > -1;
        },
        createAccount: async function  () {
            const self = this;
            const isValid = await self.checkForm();
            if(!isValid){
                Bus.$emit('changeForm', 'two')
                let data = {
                    formNumber: 'one',
                    formData:self.form
                }
                Bus.$emit('updateFormData', data);
            }
        },
    }
}
</script>
